module.exports = __webpack_public_path__ + "static/salary-80de4b5ca45e8b9cebf9fe5d18265135.jpg";